var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEventDisable = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 20,
  viewBox: "0 0 27 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.8134 0.96035C8.21575 0.98973 8.54587 1.2904 8.61262 1.68827L10.713 14.2094L13.3252 5.09203C13.4327 4.71659 13.7761 4.45789 14.1667 4.45803C14.5572 4.45817 14.9004 4.71712 15.0077 5.09265L16.7789 11.2921L17.7952 9.55739C17.9522 9.28937 18.2396 9.12469 18.5502 9.12469H20.7165C21.0882 7.94137 22.1937 7.08303 23.4997 7.08303C25.1105 7.08303 26.4163 8.38886 26.4163 9.99969C26.4163 11.6105 25.1105 12.9164 23.4997 12.9164C22.1937 12.9164 21.0882 12.058 20.7165 10.8747H19.0517L17.2546 13.942C17.0776 14.2442 16.7374 14.4117 16.3899 14.3678C16.0424 14.3238 15.7546 14.0769 15.6583 13.7401L14.1652 8.51403L11.3307 18.4074C11.2181 18.8004 10.8484 19.063 10.4402 19.04C10.0321 19.0169 9.69426 18.7143 9.62663 18.3111L7.4806 5.51802L5.9486 10.2683C5.83203 10.6297 5.49561 10.8747 5.11584 10.8747H1.33301C0.849759 10.8747 0.458008 10.4829 0.458008 9.99969C0.458008 9.51645 0.849759 9.12469 1.33301 9.12469H4.47865L6.91691 1.56445C7.04074 1.1805 7.41104 0.930971 7.8134 0.96035Z",
  fill: "#bdbdbd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEventDisable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/event_disable.7d9d6a7688635b4ae2f226e8ae42154d.svg";